import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import clsx from "clsx";
import PropTypes from "prop-types";
import "@inspire/ui/general/Panel.scss";
// TODO: Use Panel where StdPanel was used, mostly in pedagogie
var ROOT = "Panel";
var Panel = function(_param) /*#__PURE__*/ {
    var className = _param.className, children = _param.children, noPadding = _param.noPadding, compactOnMobile = _param.compactOnMobile, props = _object_without_properties(_param, [
        "className",
        "children",
        "noPadding",
        "compactOnMobile"
    ]);
    return _jsx("div", _object_spread_props(_object_spread({}, props), {
        className: clsx(ROOT, compactOnMobile && "".concat(ROOT, "--compactOnMobile"), noPadding && "".concat(ROOT, "--noPadding"), className),
        children: children
    }));
};
Panel.propTypes = {
    className: PropTypes.string,
    children: PropTypes.node,
    compactOnMobile: PropTypes.bool,
    noPadding: PropTypes.bool
};
export default Panel;
